module.exports = __webpack_public_path__ + "static/media/url.b3940d5c.png";